import { render } from "./DinoPet.vue?vue&type=template&id=fd686a32"
import script from "./DinoPet.vue?vue&type=script&lang=js"
export * from "./DinoPet.vue?vue&type=script&lang=js"
script.render = render

export default script